var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"material-kit"}},[_c('div',{attrs:{"data-app":""}},[_c('div',{class:{ 'nav-open': _vm.NavbarStore.showNavbar }},[_c('router-view',{attrs:{"name":"header"}}),_c('div',[_c('router-view')],1),_c('router-view',{attrs:{"name":"footer"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }